export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const API_FULL_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss.SSS';
export const API_FULL_FORMAT_TZ = 'YYYY-MM-DD[T]HH:mm:ss.SSS+00:00';
export const DATE_FORMAT = 'D MMM YYYY';
export const DATE_FORMAT_INPUT = 'MM/dd/y';
export const DATE_TIME_FORMAT = 'DD MMM YYYY H:mm';
export const DATE_TIME_FORMAT_INPUT = 'MM/dd/y HH:mm';
export const TIME_FORMAT = 'H:mm';
